export function stringDateToHHMM(date: string | Date) {
  return (typeof date === 'string' ? new Date(date) : date).toLocaleTimeString(
    'es-ES',
    {
      hour: '2-digit',
      minute: '2-digit',
    }
  );
}

/**
 * Convert an ISO timestamp (assumed UTC, e.g. value coming from API) into
 * a `YYYY-MM-DD` string of the provided IANA time-zone.
 *
 * It uses the built-in Intl API to avoid adding heavy deps.
 */
export function utcIsoToDateStringInZone(isoUtc: string, zone: string): string {
  // Using the canonical ISO 8601 numeric format `en-CA` (YYYY-MM-DD)
  return new Date(isoUtc).toLocaleDateString('en-CA', {
    timeZone: zone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}
